// Cíl přepínače CZ ↔ SK na druhém shopu (countrySwitch.js): stejná stránka tam,
// kde ji šablona najde jen z manifestů, jinak homepage. Tabulka schválená
// 2026-10-05 (mock ops/sweeps/2026-10-05-prepinac-cz-sk/, rozhodnutí 3A):
//   - stránka z `pages` → stránka se stejným klíčem (druhý shop ji nemá → homepage),
//   - kořen katalogu (`catalog.roots`) → stejný kořen,
//   - výsledky hledání → stejný dotaz,
//   - detail produktu → tentýž produkt podle kódu varianty; to umí jen API hledání
//     (searchApi.sisterPath), proto se vrací `codes` a homepage jako záloha,
//   - cokoli jiného (hlubší kategorie, značka, článek) → homepage.
// Čistá funkce bez DOM, unit test tools/unit/sister-target.test.mjs.

// Klíče `pages`, které se nemapují: košík a pokladna přepínač nemají (topbar,
// menu i patičku tam schovává html.bs-co-ready), `shippingOptions` je přípona
// URL produktu, ne stránka.
const SKIP = ['cart', 'checkout', 'checkoutDone', 'shippingOptions'];

/** Strop kódů variant v jednom dotazu na API (detail s mnoha variantami). */
export const MAX_SISTER_CODES = 20;

function withSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path : path + '/';
}

/**
 * @param {{pathname: string, search?: string}} loc  adresa stránky (`window.location`)
 * @param {{pageType?: string, codes?: string[]}} ctx  typ stránky a kódy variant produktu (dataLayer)
 * @param {object} own  manifest tohoto shopu (shop.js)
 * @param {object} sister  výřez manifestu druhého shopu (sister.js)
 * @returns {{href: string, codes: string[]}}  `codes` neprázdné = produkt, který dohledá API
 */
export function sisterTarget(loc, ctx, own, sister) {
  const home = sister.origin + '/';
  const at = (path) => (path ? sister.origin + path : home);
  const path = withSlash(loc.pathname || '/');

  const codes = ctx.pageType === 'productDetail' && Array.isArray(ctx.codes) ? ctx.codes.slice(0, MAX_SISTER_CODES) : [];
  if (codes.length) return { href: home, codes };

  if (path === own.pages.search) {
    // prázdná stránka výsledků bez dotazu nikomu nepomůže → homepage
    const q = (new URLSearchParams(loc.search || '').get('string') || '').trim();
    if (!q || !sister.pages.search) return { href: home, codes };
    return { href: at(sister.pages.search) + '?string=' + encodeURIComponent(q), codes };
  }
  for (const key of Object.keys(own.pages)) {
    if (SKIP.indexOf(key) < 0 && own.pages[key] === path) return { href: at(sister.pages[key]), codes };
  }
  for (const key of Object.keys(own.catalog.roots)) {
    if (own.catalog.roots[key] === path) return { href: at(sister.roots[key]), codes };
  }
  return { href: home, codes };
}
